module.exports = __webpack_public_path__ + "static/media/160.a44d873b.mp3";